module.exports = __webpack_public_path__ + "static/img/Emo_Write_App_4.817c422.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/Emo_Write_App_4.jpg
// module id = XYXQ
// module chunks = 0